import {CommonModule, Location, NgOptimizedImage} from '@angular/common';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {Injector, isDevMode, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {CookieService} from 'ngx-cookie-service';
import {AlarmComponent} from './alarm/alarm.component';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ChartComponent} from './chart/chart.component';
import {CopyrightComponent} from './copyright/copyright.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {DetailsComponent} from './details/details.component';
import {FooterComponent} from './footer/footer.component';
import {ForbiddenComponent} from './forbidden/forbidden.component';
import {HomeComponent} from './home/home.component';
import {MainComponent} from './main/main.component';
import {ModalModule} from './modal';
import {AddAlarmComponent} from './modal/add-alarm/add-alarm.component';
import {AddProjectComponent} from './modal/add-project/add-project.component';
import {InviteComponent} from './modal/invite/invite.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {OoopsComponent} from './ooops/ooops.component';
import {ProfileComponent} from './profile/profile.component';
import {ProjectComponent} from './project/project.component';
import {RightMenuComponent} from './right-menu/right-menu.component';
import {ApiService} from './service/api.service';
import {setInjector} from './shared/constants';
import {SignInComponent} from './sign-in/sign-in.component';
import {SignOutComponent} from './sign-out/sign-out.component';
import {SignUpComponent} from './sign-up/sign-up.component';
import {SystemNotificationsComponent} from './system-notifications/system-notifications.component';
import {TopMenuComponent} from './top-menu/top-menu.component';
import {UserComponent} from './user/user.component';
import {OverviewComponent} from './overview/overview.component';
import {SuccessfulComponent} from './successful/successful.component';
import {ServiceWorkerModule} from '@angular/service-worker';
import {BaseChartDirective, provideCharts, withDefaultRegisterables} from 'ng2-charts';
import {AttendeeComponent} from './attendee/attendee.component';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    HomeComponent,
    UserComponent,
    OoopsComponent,
    ChartComponent,
    AlarmComponent,
    InviteComponent,
    FooterComponent,
    SignInComponent,
    SignUpComponent,
    TopMenuComponent,
    ProfileComponent,
    DetailsComponent,
    ProjectComponent,
    SignOutComponent,
    OverviewComponent,
    AttendeeComponent,
    NotFoundComponent,
    AddAlarmComponent,
    RightMenuComponent,
    CopyrightComponent,
    ForbiddenComponent,
    DashboardComponent,
    SuccessfulComponent,
    AddProjectComponent,
    SystemNotificationsComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    FormsModule,
    ModalModule,
    BrowserModule,
    AppRoutingModule,
    BaseChartDirective,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    NgOptimizedImage,
    CommonModule
  ],
  providers: [
    CookieService,
    provideCharts(withDefaultRegisterables()),
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {

  constructor(private apiService: ApiService,
              private location: Location,
              private injector: Injector) {
    setInjector(injector);
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
